export default {
  // 通用
  defaultDishName: '默认餐盘',
  login: '登录',
  logout: '登出',
  cancel: '取消',
  confirm: '确定',
  delete: '删除',
  edit: '编辑',
  save: '保存',
  update: '更新',
  create: '创建',
  add: '添加',
  loading: '加载中...',
  
  // 主页面 - 顶部导航
  title: 'AI Prompts',
  adminEntry: '管理员入口',
  toggleSidebar: '切换侧边栏',
  
  // 主页面 - 左侧面板
  dishManagement: '餐盘管理',
  officialDish: '官方餐盘',
  shareCodeSearch: '简码搜索餐盘',
  myDishes: '我的餐盘',
  addDish: '新增餐盘',
  createFirstDish: '建立第一个餐盘',
  noDishesYet: '尚未建立任何餐盘',
  pleaseLoginFirst: '请先登录查看您的餐盘',

  // 主页面 - 中间内容区域
  loadingPromptData: '正在加载 AI Prompt 数据...',
  officialPromptDish: 'HT AI 官方指令餐盘',
  shareCodeSearchPlaceholder: '请输入分享代码',
  searchDish: '搜索餐盘',
  showAll: '全部显示',
  noPromptData: '尚无 AI Prompt 数据',
  pleaseUploadFile: '请先上传 HT_AIprompt.xlsx 文件',
  goToAdminUpload: '前往管理员上传',
  
  // 自定义餐盘视图
  promptList: '指令列表',
  addPrompt: '添加指令',
  noDishSelected: '请选择一个餐盘',
  selectDishHint: '点击左侧的餐盘来查看其内容',
  emptyDishTitle: '此餐盘尚未添加任何指令',
  emptyDishHint: '开始添加您的专属 AI 指令吧！',
  addFirstPrompt: '添加第一个指令',
  loadingPrompts: '加载指令中...',
  
  // 预览面板
  promptDetails: '指令详情',
  editPrompt: '编辑指令',
  sendToHT: '引入',
  
  // 表单字段标签
  promptCategory: '指令分类',
  promptPurpose: '指令用途',
  usage: '使用方式',
  sourceData: '来源数据',
  conditionalPrompt: '条件式指令',
  expectedOutput: '预期输出',
  followUpActions: '后续行动',
  personalNotes: '个人备注',
  creator: '创建者',
  unknown: '未知',
  
  // 分类选项
  categories: {
    score: '评分',
    general: '常用',
    quiz: '出题',
    custom: '其他自定',
    pickup: '挑选',
    mindMap: '心智图'
  },
  
  // 新增餐盘对话框
  addDishModal: {
    title: '新增 AI 指令餐盘',
    nameLabel: '餐盘名称',
    nameRequired: '餐盘名称 *',
    namePlaceholder: '请输入餐盘名称',
    descriptionLabel: '餐盘描述',
    descriptionPlaceholder: '请输入餐盘描述（选填）',
    isPublicLabel: '公开餐盘（其他用户可以查看）',
    creating: '创建中...',
    confirmCreate: '确认创建'
  },
  
  // 编辑餐盘对话框
  editDishModal: {
    title: '编辑餐盘',
    updating: '更新中...',
    confirmUpdate: '确认更新',
    defaultNameNotEditable: '默认餐盘名称无法修改',
    dishSharing: '餐盘分享',
    publishing: '发布中...',
    publishShare: '发布共用',
    closeShare: '关闭共用'
  },
  
  // 添加指令对话框
  addPromptModal: {
    title: '添加 AI 指令',
    categoryLabel: '指令分类 *',
    categoryPlaceholder: '请选择分类',
    purposeLabel: '指令用途 *',
    purposePlaceholder: '例如：生成国中数学几何单元课程大纲',
    usageLabel: '使用方式',
    usagePlaceholder: '例如：输入单元名称和年级，自动生成完整教学大纲',
    sourceDataLabel: '来源数据',
    sourceDataPlaceholder: '例如：教育部课纲、教学经验',
    conditionalPromptLabel: '条件式指令 *',
    conditionalPromptPlaceholder: '例如：请根据[单元名称]和[年级]，生成包含学习目标、教学活动、评量方式的课程大纲',
    expectedOutputLabel: '预期输出',
    expectedOutputPlaceholder: '例如：结构化的课程大纲，包含教学目标、重点概念、活动设计、评量标准',
    followUpActionsLabel: '后续行动',
    followUpActionsPlaceholder: '例如：检视大纲内容，调整教学活动顺序，准备教材',
    personalNotesLabel: '个人备注',
    personalNotesPlaceholder: '例如：适合几何单元，可搭配实体教具演示',
    adding: '添加中...',
    confirmAdd: '确认添加'
  },
  
  // 编辑指令对话框
  editPromptModal: {
    title: '编辑 AI 指令',
    categoryLabel: '指令分类 *',
    categoryPlaceholder: '请选择分类',
    purposeLabel: '指令用途 *',
    purposePlaceholder: '例如：生成国中数学几何单元课程大纲',
    usageLabel: '使用方式',
    usagePlaceholder: '例如：输入单元名称和年级，自动生成完整教学大纲',
    sourceDataLabel: '来源数据',
    sourceDataPlaceholder: '例如：教育部课纲、教学经验',
    conditionalPromptLabel: '条件式指令 *',
    conditionalPromptPlaceholder: '例如：请根据[单元名称]和[年级]，生成包含学习目标、教学活动、评量方式的课程大纲',
    expectedOutputLabel: '预期输出',
    expectedOutputPlaceholder: '例如：结构化的课程大纲，包含教学目标、重点概念、活动设计、评量标准',
    followUpActionsLabel: '后续行动',
    followUpActionsPlaceholder: '例如：检视大纲内容，调整教学活动顺序，准备教材',
    personalNotesLabel: '个人备注',
    personalNotesPlaceholder: '例如：适合几何单元，可搭配实体教具演示',
    updating: '更新中...',
    confirmUpdate: '确认更新'
  },
  
  // 删除确认对话框
  deleteConfirmModal: {
    dishTitle: '确认删除餐盘',
    promptTitle: '确认删除指令',
    deleting: '删除中...',
    confirmDelete: '确定删除'
  },
  
  // 管理员登录页面
  adminLogin: {
    title: '管理员登录',
    backButton: '← 返回',
    adminVerification: '管理员验证',
    subtitle: '请输入管理员凭证以继续',
    userIdLabel: '用户 ID',
    passphraseLabel: '管理员密钥',
    passphrasePlaceholder: '请输入管理员通关密钥',
    verifying: '验证中...',
    verifyAndLogin: '验证并登录',
    enterPassphrase: '请输入管理员密钥',
    wrongPassphrase: '管理员密钥错误，请重新输入',
    verificationFailed: '验证失败，请稍后重试',
    noLoginInfo: '未找到用户登录信息，请重新登录',
    noAdminPermission: '您没有管理员权限',
    invalidLoginInfo: '登录信息无效，请重新登录'
  },
  
  // 管理员上传页面
  adminUpload: {
    title: '管理员文件上传',
    backButton: '← 返回',
    adminBadge: '管理员',
    uploadTitle: 'AI Prompt 文件上传',
    uploadSubtitle: '支持 Excel 多语系文件，拖拽或点击上传',
    currentFileLabel: '📄 当前文件：',
    downloadCurrentFile: '（点击下载当前版本）',
    uploadWarning: '⚠️ 上传新文件将会覆盖现有的 HT_AIprompt.xlsx 文件',
    dropZoneText: '拖拽文件到此处或',
    selectFile: '选择文件',
    supportedFormat: '支持格式：.xlsx',
    startUpload: '开始上传',
    uploading: '正在上传...',
    onlyXlsxSupported: '仅支持 Excel (.xlsx) 格式文件',
    fileTooLarge: '文件大小不能超过 10MB',
    uploadSuccess: 'AI Prompt Excel文件上传完成',
    uploadFailed: '文件上传失败，请重试',
    noValidLanguageData: 'Excel文件中没有找到有效的语言数据',
    cannotGetUploadPermission: '无法获取上传权限'
  },
  
  // 成功/错误消息
  messages: {
    loginSuccess: '登录成功！',
    loginFailed: '登录失败',
    logoutSuccess: '登出成功',
    logoutFailed: '登出失败',
    adminVerificationSuccess: '管理员验证成功！',
    dishCreated: '餐盘创建成功！',
    dishUpdated: '餐盘更新成功！',
    dishDeleted: '餐盘已删除',
    promptAdded: '指令添加成功！',
    promptUpdated: '指令更新成功！',
    promptDeleted: '指令已删除',
    copied: '内容已复制到剪贴板',
    copyFailed: '复制失败',
    pleaseSelectDishFirst: '请先选择一个餐盘',
    pleaseLoginToAddDish: '请先登录后再新增餐盘',
    pleaseLoginToAddPrompt: '请先登录后再添加指令',
    pleaseLogin: '请先登录',
    pleaseEnterDishName: '请输入餐盘名称',
    pleaseFillRequiredFields: '请填写必填字段',
    noDataChanges: '数据未有变更，无需保存',
    dishNotPublic: '餐盘拥有者已设为不公开',
    missingRequiredInfo: '缺少必要信息',
    dishNameRequired: '餐盘名称 *',
    dishIdError: '餐盘ID错误',
    promptIdError: '缺少指令 ID',
    loadSuccess: '成功加载 {count} 个 AI Prompt 分类',
    noValidCategoryData: '文件中没有找到有效的分类数据',
    pleaseSelectPlateAndConfirmData: '请选择餐盘和确认指令数据',
    promptAddedToPlate: '指令已成功加入到「{plateName}」餐盘',
    addPromptToPlateFailed: '加入指令失败：{error}',
    loadFailed: '加载失败：{error}',
    cannotReadFile: '无法读取文件',
    createDishFailed: '创建餐盘失败：{error}',
    updateDishFailed: '更新餐盘失败：{error}',
    checkFailed: '检查失败：{error}',
    addPromptFailed: '添加指令失败：{error}',
    updatePromptFailed: '更新指令失败：{error}',
    sentToHT: '指令资料已发送到 HT',
    outputToConsole: '指令资料已输出到 Console (非 WebView 环境)',
    sendFailed: '传送失败，请查看 Console',
    dishPublished: '餐盘已发布共用',
    dishShareClosed: '已关闭餐盘共用',
    noShareLinkToCopy: '无分享链接可复制',
    shareLinkCopied: '分享链接已复制到剪贴板',
    copyLinkFailed: '复制失败，请手动复制',
    publishFailed: '发布失败：{error}',
    closeShareFailed: '关闭共用失败：{error}'
  },

  // 分享指令到餐盘
  shareToPlate: {
    title: '请选择要加入的餐盘',
    selectPlate: '选择餐盘',
    selectPlaceholder: '请选择餐盘',
    promptContent: '指令内容',
    adding: '加入中...',
    addToPlate: '加入',
    cancel: '取消',
    success: '指令已成功加入到「{plateName}」餐盘',
    noPlateSelected: '请选择餐盘和确认指令资料',
    noPromptData: '没有收到分享的指令资料',
    loginRequired: '请先登录才能分享指令到餐盘',
    noPlatesAvailable: '您还没有任何餐盘，请先建立餐盘',
    addFailed: '加入指令失败：{error}',
    // 预览区域标签
    previewLabels: {
      promptPurpose: '指令用途',
      promptCategory: '指令分类',
      usage: '用法',
      sourceData: '来源数据',
      conditionalPrompt: '条件指令内容',
      expectedOutput: 'AI输出',
      followUpActions: '后续动作',
      personalNotes: '个人笔记'
    }
  },
  
  // 通用提示文字
  tooltips: {
    edit: '编辑',
    delete: '删除'
  },
  
  // 复制内容时的标签
  copyLabels: {
    purpose: '指令用途',
    category: '指令分类',
    usage: '使用方式',
    conditionalPrompt: '条件式指令',
    expectedOutput: '预期输出'
  },
  
  // 删除确认消息
  deleteConfirm: {
    dishWithPrompts: '餐盘「{name}」内包含 {count} 个指令。\n删除餐盘将同时删除内部所有指令，此操作无法复原。\n确定要继续吗？',
    dishWithoutPrompts: '确定要删除餐盘「{name}」吗？此操作无法复原。',
    prompt: '确定要删除指令「{name}」吗？此操作无法复原。'
  },
  
  // 成功消息模板
  successMessages: {
    dishDeletedWithPrompts: '餐盘「{name}」及其内部 {count} 个指令已全部删除',
    dishDeleted: '餐盘「{name}」已删除',
    promptDeleted: '指令已删除'
  },
  
  // 错误消息
  errors: {
    onlyXlsxSupported: '仅支持 Excel (.xlsx) 格式文件',
    fileTooLarge: '文件大小不能超过 10MB',
    fileTooLargeWithSize: '文件大小不能超过 10MB，目前文件大小：{size}',
    excelParseFailed: 'Excel解析失败：{error}',
    fileReadFailed: '文件读取失败',
    cannotGetUploadPermission: '无法获取上传权限',
    uploadFailed: '上传失败：{error}',
    sasTokenExpired: 'SAS Token 已过期，请重新获取',
    uploadPermissionInsufficient: '上传权限不足，请重新获取 SAS Token',
    containerNotExists: '容器不存在',
    dishNotExistsOrDeleted: '餐盘不存在或已被删除',
    noPermissionToDelete: '没有权限删除此餐盘',
    deleteDishFailed: '删除餐盘失败：{error}',
    deletePromptFailed: '删除指令失败：{error}',
    generateDownloadUrlFailed: '生成下载 URL 失败',
    tokenParseFailed: 'Token 解析失败',
    completeAdminVerificationFirst: '请先完成管理员验证',
    loginInfoInvalid: '登录信息无效，请重新登录',
    unknownError: '未知错误',
    fileUploadFailed: '文件上传失败，请重试',
    noValidLanguageData: 'Excel文件中没有找到有效的语言数据',
    shareCodeSearchFailed: '搜索失败，请检查分享代码是否正确，或使用者已设置为不公开',
    shareCodeNotFound: '找不到此分享代码对应的餐盘'
  }
};